import React, { useState,useEffect } from 'react';
import { Route, Switch } from 'react-router';
import Layout from './components/Layout';
import LoginPage from './components/Login';
import { connect } from 'react-redux';
import { ApplicationState } from './store';
import { actionCreators } from './store/User';
import { actionCreators as alertActionCreators } from './store/AlertState';
import { MEBUser, logout } from './services/userService';
import { Dispatch, bindActionCreators } from 'redux';
import { history } from './utils/history';
import ga from './utils/ga';
import { PrivateRoute } from './utils/PrivateRoute';

import Dashboard from './components/Dashboard';
import BorrowEmployee from './components/BorrowEmployeeUI';

interface LoginState {
    user: MEBUser | undefined;
}

type AppProps = LoginState & typeof actionCreators & typeof alertActionCreators;

const App: React.FC<AppProps> = (props: AppProps): JSX.Element => {
    const { clear, loadSavedUser, logout } = props;   
    useEffect(() => {
        history.listen(location => {
            ga.pageView(location.pathname);
            clear();
        });

        loadSavedUser();

        const handleBeforeUnload = (event: BeforeUnloadEvent) => { logout(); };
        window.addEventListener('beforeunload', handleBeforeUnload);    


        return () => { window.removeEventListener('beforeunload', handleBeforeUnload); };
    }, [clear, loadSavedUser, logout]);

    useEffect(() => {
        if (!props.user) {
            logout();
        }
    }, [props.user, logout]);

    return (
    
        <Layout>
            <Switch>
                {/* Default route for Dashboard with BorrowEmployee */}
                <PrivateRoute exact path='/' render={() => (
                    <Dashboard>
                        <BorrowEmployee />
                    </Dashboard>
                )} />

                {/* Login Route */}
                <Route path='/login' component={LoginPage} />
            </Switch>
        </Layout>
  
    );
}

const mapState = (state: ApplicationState) => ({
    user: state.user
})

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators({ ...actionCreators, ...alertActionCreators }, dispatch)

export default connect(mapState, mapDispatchToProps)(App);
